export default __webpack_public_path__ + "static/media/banner.12f6f12d.png";